
import { CommonData } from "../../datastructures/gamestate/gameData";
import {
  createMovieClip,
  createMovieClipWithXLoops,
} from "../../functions/Functions_General";

export class GambleNewMiniGame {
  private parent = new PIXI.Container();
  private charFramesParent = new PIXI.Container();
  private charFrames: GambleFrames[] = [];
  private versusSlider:VersusSlider;
  private gambleLeft:Gambleleft;
  private instructionsBar:InstructionsBar;
  private versusLabel= new PIXI.Sprite(PIXI.Texture.fromFrame('VS_centerBig.png'));
  private activeGameData:CommonData;
  private resultHistory:ResultHistoryViewer;
  private currentValueDisplay:GambleAmountDisplayer;
  private targetValueDisplay:GambleAmountDisplayer;
  private winLoseTextDisplayer:WinLoseTextDisplayer;
  constructor(parent: PIXI.Container,activeGameData:CommonData) {
    this.activeGameData=activeGameData;
    parent.addChild(this.parent);
    this.parent.addChild(this.charFramesParent);
    this.setUpCharactersFrame();  
    this.setUpVersusNumbers();
    this.setUpSlider();
    this.setupInstructionBar();
    this.addVersus();
    this.createResultsViewer();
    this.createCurrentAndTargetViwer();
    this.createWinLoseTextDisplayer();
    this.parent.y=-25;
  }
  private createWinLoseTextDisplayer=():void=>
  {
    this.winLoseTextDisplayer= new WinLoseTextDisplayer(this.parent,this.activeGameData);
    this.winLoseTextDisplayer.displayTextResult(true);
    this.winLoseTextDisplayer.setPosition(this.charFramesParent.width/2,350);
  }
  public displayWinLose=(isWin:boolean):void=>
  {
    this.winLoseTextDisplayer.displayTextResult(isWin);
  }
  public enableBtnClickable=(bool:boolean):void=>
  {
     
      for (let i = 0; i < this.charFrames.length; i++) {
        this.charFrames[i].setBtnClickable(bool);
        
      }
      if(bool)
      {
        this.winLoseTextDisplayer.clear();
      }
  }
  private createCurrentAndTargetViwer=():void=>
  { 
    let containerDisplayValue= new PIXI.Container;
    this.parent.addChild(containerDisplayValue)
    this.currentValueDisplay= new GambleAmountDisplayer(containerDisplayValue,this.activeGameData);
    this.targetValueDisplay= new GambleAmountDisplayer(containerDisplayValue,this.activeGameData);
    this.currentValueDisplay.setLabelText(this.activeGameData.gameTextGeneral.gambleAmount);
    this.targetValueDisplay.setLabelText(this.activeGameData.gameTextGeneral.gambleToWin);

    //---set position

    this.currentValueDisplay.setPosition(this.charFramesParent.width/2,480);
    this.targetValueDisplay.setPosition(this.charFramesParent.width/2,590);
    this.currentValueDisplay.setScale(0.70);
    this.targetValueDisplay.setScale(0.85);
  }
  private createResultsViewer=():void=>
  {
    this.resultHistory= new ResultHistoryViewer(this.parent,this.activeGameData);
    this.resultHistory.setPosition(this.charFramesParent.width/2,715);
  }
  private addVersus=():void=>
  {
    this.parent.addChild(this.versusLabel);
    this.versusLabel.anchor.set(.5);
    this.versusLabel.x=this.charFramesParent.width/2;
    this.versusLabel.y=355;
  }
  public getGambleContainer=():PIXI.Container=>
  {
    return this.parent;
  }
  public getFrameContainer=():PIXI.Container=>
  {
    return this.charFramesParent;
  }
  private setupInstructionBar=():void=>
  {
    let instructionContainer= new PIXI.Container();
    this.parent.addChild(instructionContainer)
    this.instructionsBar= new InstructionsBar(instructionContainer,this.activeGameData);
    instructionContainer.x=this.charFramesParent.width/2;
    instructionContainer.y=65;
    this.instructionsBar.setPosition(0,0)
  }
  private setUpSlider=():void=>
  {
    let sliderContainer= new PIXI.Container();
    this.parent.addChild(sliderContainer)
    this.versusSlider=new VersusSlider(sliderContainer,this.charFramesParent.width);
    this.versusSlider.setPosition(0,120);
  }
  private setUpVersusNumbers=():void=>
  {
    
    let versusContainer= new PIXI.Container();
    this.parent.addChild(versusContainer)
    this.gambleLeft=new Gambleleft(versusContainer,this.activeGameData);
    this.gambleLeft.setPosition(this.charFramesParent.width/2,165);
    this.gambleLeft.Setlabel(this.activeGameData.gameTextGeneral.gambleLeft);
  }
  private setUpCharactersFrame = (): void => {
    for (let i = 0; i < 2; i++) {
      this.charFrames[i] = new GambleFrames(this.charFramesParent, i,this.activeGameData);
    }
  };
  public onSelect=(hasWon:boolean, frameIndex:number):void=>
  {
    // console.log(hasWon,frameIndex)
      let nicoFrameIndex=(frameIndex==0||frameIndex==2)?0:1;
      this.charFrames[nicoFrameIndex].playerPickResult(hasWon);

  }
  public updateGambleAmount=(currentValue:string,targetValue:string):void=>
  {
    this.currentValueDisplay.setValueText(currentValue);
    this.targetValueDisplay.setValueText(targetValue);
  }
  // public update
  public updateHisory=():void=>
  {
    //
    this.activeGameData.betResponse.gameContext.contextData.gambleHistory;
    //0 and 1 red --------- 2 and 3 black
    let historyArray:number[]=this.activeGameData.betResponse.gameContext.contextData.gambleHistory;
    if(historyArray.length>0)
    {      
      this.resultHistory.clearAll();      
      this.resultHistory.loadHistory(historyArray);
    }
    else
    {   
      this.resultHistory.clearAll();
    }

    //set gamble leftamount;
    this.gambleLeft.setGambleLeft(0);

    if(this.activeGameData.betResponse.gameContext.contextData.gamblesLeft!=undefined)
    {
    this.gambleLeft.setGambleLeft(this.activeGameData.betResponse.gameContext.contextData.gamblesLeft);
    }

  }





  public setVisible=(bool:boolean):void=>
  {
    this.parent.alpha=bool?1:0;
   //hide unhide elements
  for (let i = 0; i < this.charFrames.length; i++) {
    this.charFrames[i].setVisible(bool);
  }
  this.versusSlider.setVisible(bool);
  
  this.instructionsBar.setVisible(bool);

  }

  

}
class GambleFrames {
  private parent = new PIXI.Container();
  private backgroundTextureBaseBlue = PIXI.Texture.fromFrame(
    "gambleBaseFrame.png"
  );
  private backgroundTextureWinBlue = PIXI.Texture.fromFrame(
    "gambleWinFrame.png"
  );

  private backgroundTextureBaseRed = PIXI.Texture.fromFrame(
    "gambleBaseFrameRed.png"
  );
  private backgroundTextureWinRed = PIXI.Texture.fromFrame(
    "gambleWinFrameRed.png"
  );
  private background: PIXI.Sprite;
  private charNumber: number;
  private characterContainer = new PIXI.Container();
  private character: GambleCharacter;
  // private smileyHistoryContainer=new PIXI.Container();
  // private smileyArrayResultHistory: ResultSmiley[]=[];
  //--
  private activeGameData:CommonData;
  private labelBtn:GambleColorBtn;
  constructor(parent: PIXI.Container, CharacterIndex: number,activeGameData:CommonData) {
    this.activeGameData=activeGameData;
    this.charNumber = CharacterIndex;
    parent.addChild(this.parent);
    this.createBG();
    this.createChar();
    this.createBtn();
    // this.createSmileyArrayResultHistory();
    this.createLabels();
    this.setlayout();
  }
  public setVisible=(bool:boolean):void=>
  {
    this.character.setVisible(bool);

  }
  public setBtnClickable=(bool:boolean):void=>
  {
      this.labelBtn.setClickable(bool);

  }
  // public updateSmileys=(smileyArray:number[]):void=>
  // {
 
  //   //clear first all smileys
  //   for (let i = 0; i <this.smileyArrayResultHistory.length; i++) {
  //     this.smileyArrayResultHistory[i].setVisible(false);
  //   }
  //   for (let i = 0; i < smileyArray.length; i++) {
    
  //     this.smileyArrayResultHistory[i].setFaceindex(smileyArray[i]);
      
  //   }
  //   //--
  // }
  private createLabels=():void=>
  {
    //non clicable , just as label
    let labelContainer=new PIXI.Container();
    this.parent.addChild(labelContainer);
    this.labelBtn=new GambleColorBtn(labelContainer,this.charNumber,this.activeGameData);
    // this.labelBtn;
    if(this.charNumber===0)
    {
        this.labelBtn.setBtnBGParentPosX(this.background.texture.width);
      
    }
    this.labelBtn.setPosition(0, this.background.height-60);
  }
  // private createSmileyArrayResultHistory=():void=>
  // { 
  //       this.parent.addChild(this.smileyHistoryContainer);
  //       for (let i = 0; i < 5; i++) {
  //           this.smileyArrayResultHistory[i]= new ResultSmiley(this.smileyHistoryContainer)
  //           this.smileyArrayResultHistory[i].setPosition(0,70*i);
  //           this.smileyArrayResultHistory[i].setVisible(false);
  //           // this.smileyArrayResultHistory[i].setFaceindex(Math.random()>0.5?1:0);
  //       }
  //       let posX=50;
  //       if(this.charNumber==1){posX=this.background.width-50;}
  //       this.smileyHistoryContainer.position.set(posX,220)
  // }
  private createBtn = (): void => {
    // this.background.on("pointertap", this.onClick);
    // this.background.buttonMode = true;
    // this.background.interactive = true;
  };
  // private onClick = (): void => {
  //   //disable the btn until the end of animation for both btn
  //   this.character.startTransition(Math.random()>.5);
  // };

  public playerPickResult=(hasWon:boolean):void=>
  {
    this.character.startTransition(hasWon);
  }
  private setlayout = (): void => {
    this.parent.x = this.background.width * this.charNumber;
  };
  private createChar = (): void => {
    this.parent.addChild(this.characterContainer);
    this.character = new GambleCharacter(
      this.characterContainer,
      this.charNumber
    );
    this.characterContainer.y=-5;
  };
  private createBG = (): void => {
   

    if (this.charNumber == 0) {
      //red
      this.background = new PIXI.Sprite(this.backgroundTextureBaseRed);
    } else {
      //blue
  
      this.background = new PIXI.Sprite(this.backgroundTextureBaseBlue);
    }
    this.parent.addChild(this.background);
  };
  public setBgWin = (bool: Boolean): void => {
    this.background.texture = bool
      ? (this.charNumber===0?this.backgroundTextureWinRed:this.backgroundTextureWinBlue)
      : (this.charNumber===0?this.backgroundTextureBaseRed:this.backgroundTextureBaseBlue);
  };
  // public startSelectAnimation=(hasWon:boolean):void=>
  // {
  //   this.character.setVisible
  // }
}

class GambleCharacter {
  private parent = new PIXI.Container();
  // private backgroundTextureBaseBlue=PIXI.Texture.fromFrame( 'gambleBaseFrame.png');
  // private backgroundTextureWinBlue=PIXI.Texture.fromFrame( 'gambleWinFrame.png');
  private characterIldeBlue1 = createMovieClip("nico_blue_idle_a", 0, 100);
  private characterIldeBlue2 = createMovieClip("nico_blue_idle_b", 0, 100);

  private characterIldeRed1 = createMovieClip("nico_red_idle_a", 0, 100);
  private characterIldeRed2 = createMovieClip("nico_red_idle_a", 0, 100);

  private characterWinBlue1 = createMovieClipWithXLoops(
    "nico_blue_win",
    0,
    30,
    2
  );
  private characterWinRed1 = createMovieClipWithXLoops(
    "nico_red_win",
    0,
    30,
    2
  );

  private characterLoseBlue1 = createMovieClipWithXLoops(
    "nico_blue_lost",
    0,
    30,
    2
  );
  private characterLoseRed1 = createMovieClipWithXLoops(
    "nico_red_lost",
    0,
    30,
    2
  );

  private TransitionEffectHappy = createMovieClip(
    "transition_emoji_smile",
    0,
    50
  );
  private TransitionEffectSad = createMovieClip("transition_emoji_cry", 0, 50);

  private TransitionEffectHearts = createMovieClip(
    "transition_emoji_heart",
    0,
    60
  );

  private TransitionList: PIXI.extras.AnimatedSprite[] = [];
  //--
  private activeTransitionEffect = createMovieClip(
    "transition_emoji_cry",
    0,
    50
  );
  private idleBlueList: PIXI.extras.AnimatedSprite[] = [];
  private idleRedList: PIXI.extras.AnimatedSprite[] = [];
  //---
  private visibleCharacter: PIXI.extras.AnimatedSprite;
  private charNumber: number;
  private swappedToResult: boolean = false;
  //---cycle
  // return to Idle

  constructor(parent: PIXI.Container, CharacterIndex: number) {
    this.charNumber = CharacterIndex;
    parent.addChild(this.parent);
    this.createAnimArray();
    this.createCharAndAnimations();
    this.createBackToIdleListener();
    this.createTransisionAnimation();
    this.createTransitionListener();

    this.reset();
    this.setVisible(true);
    
    //--
    // this.playIdle();
    // this.playWin();
    // this.playLose();
  }

  private createTransisionAnimation = (): void => {
    this.TransitionList.push(this.TransitionEffectSad);
    this.TransitionList.push(this.TransitionEffectHappy);
    // this.TransitionList.push(this.TransitionEffectHearts);
    this.activeTransitionEffect.loop = false;
    this.TransitionEffectHearts.loop = false;
    this.parent.addChild(this.activeTransitionEffect);
    this.parent.addChild(this.TransitionEffectHearts);
    //create listeners
  };
  private createTransitionListener = (): void => {
    //on end listener
    this.activeTransitionEffect.onComplete = this.hideTransitionAnimation;
    this.TransitionEffectHearts.onComplete = this.hideTransitionAnimation;
    //while playing
    this.activeTransitionEffect.onFrameChange = this.onFrameChageOnTransistionSwitchCharacter;

    this.TransitionEffectHearts.onFrameChange = this.onFrameChageOnHeartsTransistion;
  };
  private onFrameChageOnTransistionSwitchCharacter = (): void => {
    if (this.swappedToResult === false) {
      if (this.activeTransitionEffect.currentFrame >= 35) {
        // console.log("SWITCH TO HAPPY/SAD");
        this.swappedToResult = true;
        if (
          this.activeTransitionEffect.textures ===
          this.TransitionEffectHappy.textures
        ) {
          this.playWin();
        } else if (
          this.activeTransitionEffect.textures ===
          this.TransitionEffectSad.textures
        ) {
          this.playLose();
        }
      }
    }
  };
  private onFrameChageOnHeartsTransistion = (): void => {
    let isPlayingLose1 =
      this.visibleCharacter.textures === this.characterLoseRed1.textures;
    let isPlayingLose2 =
      this.visibleCharacter.textures === this.characterLoseBlue1.textures;
    let isPlayingWin1 =
      this.visibleCharacter.textures === this.characterWinRed1.textures;
    let isPlayingWin2 =
      this.visibleCharacter.textures === this.characterWinBlue1.textures;

    let isPlayingNonIdleAnimation =
      isPlayingLose1 || isPlayingLose2 || isPlayingWin1 || isPlayingWin2;
    if (
      this.TransitionEffectHearts.currentFrame >= 27 &&
      isPlayingNonIdleAnimation
    ) {
      this.playIdle();
      this.swappedToResult = false;
    }
  };
  private createBackToIdleListener = (): void => {
    this.visibleCharacter.onFrameChange = () => {
      if (this.visibleCharacter.currentFrame >= this.visibleCharacter.totalFrames - 10 && this.TransitionEffectHearts.playing===false &&
        (
          this.visibleCharacter.textures === this.characterWinBlue1.textures ||
      this.visibleCharacter.textures === this.characterWinRed1.textures ||
      this.visibleCharacter.textures === this.characterLoseBlue1.textures ||
      this.visibleCharacter.textures === this.characterLoseRed1.textures )
        
        ) {
        this.exitTransition();
      }
    };
  };
  

  // private
  private exitTransition = (): void => {
    // if (
    //   this.visibleCharacter.textures === this.characterWinBlue1.textures ||
    //   this.visibleCharacter.textures === this.characterWinRed1.textures ||
    //   this.visibleCharacter.textures === this.characterLoseBlue1.textures ||
    //   this.visibleCharacter.textures === this.characterLoseRed1.textures
    // )
    //   // this.playTransition(2);//exit animation;
      this.TransitionEffectHearts.gotoAndPlay(0);
    this.TransitionEffectHearts.alpha = 1;
  };
  private hideTransitionAnimation = (): void => {
    this.activeTransitionEffect.alpha = 0;
    this.activeTransitionEffect.gotoAndStop(0);

    this.TransitionEffectHearts.alpha = 0;
    this.TransitionEffectHearts.gotoAndStop(0);
  };

  private playTransition = (index: number): void => {
    this.activeTransitionEffect.textures = this.TransitionList[index].textures;
    this.activeTransitionEffect.alpha = 1;
    this.activeTransitionEffect.gotoAndPlay(0);
    this.activeTransitionEffect.tint=(index===0?0x7F7F7F:0xffffff)
  };
  private createAnimArray = (): void => {
    this.idleBlueList.push(this.characterIldeBlue1);
    this.idleBlueList.push(this.characterIldeBlue2);
    this.idleRedList.push(this.characterIldeRed1);
    this.idleRedList.push(this.characterIldeRed2);
  };
  private createCharAndAnimations = (): void => {
    if (this.charNumber == 0) {
      //red
      this.visibleCharacter = createMovieClip("nico_red_idle_a", 0, 100);
    } else {
      //blue
      this.visibleCharacter = createMovieClip("nico_blue_idle_a", 0, 100);
    }
    this.parent.addChild(this.visibleCharacter);
    this.visibleCharacter.gotoAndPlay(0);
    this.visibleCharacter.loop = true;
  };
  private playIdle(): void {
    this.visibleCharacter.loop = true;
    const idleList =
      this.charNumber === 0
        ? this.idleRedList
        : this.charNumber === 1
        ? this.idleBlueList
        : null;

    if (!idleList) {
      return; // Exit the function if charNumber is neither 0 nor 1
    }

    const randomIndex = 0; // this.charNumber//Math.floor(Math.random() * idleList.length);
    const randomStartFrame = Math.floor(
      idleList[randomIndex].totalFrames * Math.random()
    );

    this.visibleCharacter.textures = idleList[randomIndex].textures;
    this.visibleCharacter.gotoAndPlay(randomStartFrame);
  }
  public startTransition = (playerWon: boolean): void => {
    this.reset();
    this.parent.alpha=1;
    if (playerWon) {
      this.playTransition(1);
    } else {
      this.playTransition(0);
    }
  };

  private reset = (): void => {
    this.swappedToResult = false;
    this.hideTransitionAnimation();
    if (
      this.visibleCharacter.textures === this.characterWinRed1.textures ||
      this.visibleCharacter.textures === this.characterLoseRed1.textures ||
      this.visibleCharacter.textures === this.characterWinBlue1.textures ||
      this.visibleCharacter.textures === this.characterLoseBlue1.textures
    ) {
      this.playIdle();
    }
  };
  public setVisible = (bool:boolean): void => {

    if(bool)
    {
        this.hideTransitionAnimation();
        this.visibleCharacter.gotoAndPlay(0);
        this.parent.alpha = 1;
    }
    else
    {
        this.hideTransitionAnimation();
        this.visibleCharacter.gotoAndStop(0);
        this.parent.alpha = 0;
    }

  };
  private playWin(): void {
    this.visibleCharacter.loop = false;

    const winAnim =
      this.charNumber === 0
        ? this.characterWinRed1
        : this.charNumber === 1
        ? this.characterWinBlue1
        : null;
    if (!winAnim) {
      return; // Exit the function if charNumber is neither 0 nor 1
    }
    this.visibleCharacter.textures = winAnim.textures;
    this.visibleCharacter.gotoAndStop(0);
    this.visibleCharacter.gotoAndPlay(0);
  }

  private playLose(): void {
    this.visibleCharacter.loop = false;
    const loseAnim =
      this.charNumber === 0
        ? this.characterLoseRed1
        : this.charNumber === 1
        ? this.characterLoseBlue1
        : null;

    if (!loseAnim) {
      return; // Exit the function if charNumber is neither 0 nor 1
    }
    this.visibleCharacter.textures = loseAnim.textures;
    this.visibleCharacter.gotoAndStop(0);
    this.visibleCharacter.gotoAndPlay(0);
  }
}



class GambleColorBtn
{
    private parent = new PIXI.Container();
    private btnBGParent = new PIXI.Container();
    private btnImgRedTexture =(PIXI.Texture.fromFrame('gameble_btnRed.png'));
    private btnImgBlueTexture=(PIXI.Texture.fromFrame('gameble_btnBlue.png'));
    private btn:PIXI.Sprite;
    private btnIndex:number;
    private labelText:PIXI.Text;
    private activeGameData:CommonData;
    private animationTween:PIXI.tween.Tween;
    private animationTextTween:PIXI.tween.Tween;
    constructor(parent:PIXI.Container,btnColorIndex:number,activeGameData:CommonData)
    {   this.activeGameData=activeGameData;
        parent.addChild(this.parent);
        this.parent.addChild(this.btnBGParent);
        this.btnIndex=btnColorIndex;
        this.btn=new PIXI.Sprite(btnColorIndex===0?this.btnImgRedTexture:this.btnImgBlueTexture);
        //-
        let strokeColor= this.btnIndex===0?"#dc1c39":"#60b1f1"
        const style = new PIXI.TextStyle({
            fill: "#ffffff",
            fontFamily:   this.activeGameData.gameTextStyle.gameFont,
            fontSize: 50,
            fontStyle: "italic",
            fontWeight: "bolder",
            lineJoin: "round",
            stroke: strokeColor,
            strokeThickness: 10
        });
       
        this.labelText= new PIXI.Text((this.btnIndex==0)?this.activeGameData.gameTextGeneral.red:this.activeGameData.gameTextGeneral.blue,style);
        this.btn.anchor.set(0,.5);
       
        this.btn.x=-this.btn.width/2;
        if(this.btnIndex==0)
        {
          this.btn.anchor.set(1,.5);
          this.btn.x=this.btn.width/2;
        }
        this.labelText.anchor.set(.5);
        this.btnBGParent.addChild(this.btn);   
        this.btnBGParent.addChild(this.labelText);


        this.btnBGParent.x=this.btnIndex==0?-this.btnBGParent.width/2:this.btnBGParent.width/2;
        
        //create tween;
        // console.log(this.btnIndex)
        this.animationTween= PIXI.tweenManager.createTween(this.btn);
        this.animationTween.from({scale:{x: 1,y:1}}).to({scale:{x: 1.1,y:1}})
        this.animationTween.time = 750;
        this.animationTween.loop = true;
        this.animationTween.pingPong = true;
        this.animationTween.delay=(this.btnIndex*500);
        // this.animationTween.on("repeat",this.CreateRandomMovingTweenValue);   
        // this.animationTween.start();
        this.animationTween.easing = PIXI.tween.Easing.outExpo();


        this.animationTextTween= PIXI.tweenManager.createTween(this.labelText);
        this.animationTextTween.from({scale:{x: 1,y:1}}).to({scale:{x: 1.3,y:1.3}})
        this.animationTextTween.time = 750;
        this.animationTextTween.loop = true;
        this.animationTextTween.pingPong = true;
        this.animationTextTween.delay=(this.btnIndex*500);
        // this.animationTween.on("repeat",this.CreateRandomMovingTweenValue);   
        // this.animationTextTween.start();
        this.animationTextTween.easing = PIXI.tween.Easing.outExpo();
    }
    public setClickable=(bool:boolean):void=>
    {
      this.btn.tint=bool?0xffffff:0x333333;
      this.labelText.tint=bool?0xffffff:0x333333;
      this.startAnimation(bool);
    }
    public setBtnBGParentPosX=(posX:number):void=>
    {
        this.btnBGParent.x=posX-this.btnBGParent.width/2;
    }
    public setPosition=(posX:number,posY:number):void=>
    {
        this.parent.position.set(posX,posY)
    }
    private startAnimation=(bool:boolean):void=>
    { 
      if(bool)
      { 
        this.animationTween.reset();
        this.animationTextTween.reset();
        this.animationTween.start();
        this.animationTextTween.start();
      }
      else
      {
        
          this.animationTween.reset();
          this.animationTextTween.reset();
          this.animationTween.stop();
          this.animationTextTween.stop();
        
      }
     
    }

}

class VersusSlider
{   
  // battleBar_blue
    private parent= new PIXI.Container();
    private redBG= new PIXI.Sprite(PIXI.Texture.fromFrame('battleBar_red.png'));
    private blueBG=new PIXI.Sprite(PIXI.Texture.fromFrame('battleBar_blue.png'));
    // private maskColorParent= new PIXI.Container();
    // private maskColor:PIXI.Graphics;
    private maskParent:PIXI.Graphics;
    private moveTween:PIXI.tween.Tween;
    private widthVal:number;
    private maskPosition:number;
    private maskTarget:number;
    constructor(parent:PIXI.Container,widthValue:number)
    {
            parent.addChild(this.parent);
            // this.parent.addChild(this.maskColorParent);
            this.widthVal=widthValue;
            this.createShapes();   
            this.createTween();
          
    }
    public setVisible=(bool:boolean):void=>
    {
     this.parent.alpha=bool?1:0;
     if(bool)
     {
      this.moveTween.start();
     }
     else
     {
      this.moveTween.stop();
     }
   
  
    }
    private createShapes=():void=>
    {
        // this.redBG=new PIXI.Graphics().beginFill(0xff2c4a).drawRect(0,-25,this.widthVal,50).endFill();
        // this.blueBG=new PIXI.Graphics().beginFill(0x4071fa).drawRect(0,-25,this.widthVal,50).endFill();
        // this.maskColor=new PIXI.Graphics().beginFill(0xffffff).drawRoundedRect(-25,-25,this.widthVal+50,50,25).endFill();
        this.maskParent=new PIXI.Graphics().beginFill(0xffffff,.5).drawRect(5,-25,this.widthVal-10,100).endFill();
        this.parent.addChild(this.blueBG);
        this.parent.addChild(this.redBG);
        this.redBG.anchor.set(0.5,0)
        // this.maskColorParent.addChild(this.maskColor);
        this.parent.addChild(this.maskParent);
        //apply first mask
   
        //apply second mask
        this.parent.mask=this.maskParent;
    }
    public setPosition=(newPosX:number,newPosY:number):void=>
    {
        this.parent.position.set(newPosX,newPosY);
    }
    private createTween=():void=>
    {
     
        this.moveTween = PIXI.tweenManager.createTween(this.redBG);
        this.moveTween.time = 500;
        this.moveTween.loop = true;
        this.moveTween.on("repeat",this.CreateRandomMovingTweenValue);        
        this.moveTween.easing = PIXI.tween.Easing.outSine();
        this.CreateRandomMovingTweenValue();
        this.maskTarget=0;
        this.maskPosition=0;
              this.moveTween.start();
    }
    private getRandomTargetValue=():number=>
    {
      //-generate new targert
      let randomValue=(Math.random()*100)+50;//steps
      if(this.redBG.x>this.widthVal/3 && randomValue>0)
      {
        randomValue=randomValue*-1;
      }
      else  if(this.redBG.x<-this.widthVal/3 && randomValue<0)
      {
        randomValue=randomValue*-1;
      }

      return randomValue;

    }
    private CreateRandomMovingTweenValue=():void=>
    {
    
     
        this.maskPosition=this.maskTarget;
        this.maskTarget=this.getRandomTargetValue();
        this.moveTween
        .from({x:this.maskPosition});
        this.moveTween
          .to({x: this.maskTarget});
      
        // this.moveTween.reset();
  
    }
}



class Gambleleft
{ 
  private parent= new PIXI.Container();
  private activeGameData:CommonData;
  private bgImage=new PIXI.Sprite(PIXI.Texture.fromFrame('gamblescoreRecap.png'));
  private gameLeft:number=0;
  private gameLeftText:PIXI.Text;
  private gameLeftLabelText:PIXI.Text;
  constructor(parent:PIXI.Container,activeGameData:CommonData)
  {
    parent.addChild(this.parent);
    this.activeGameData=activeGameData;

    this.bgImage.anchor.set(.5,0);
    this.bgImage.scale.set(1.3);
    this.bgImage.y=-25;
    this.parent.addChild(this.bgImage);



    
    const style = new PIXI.TextStyle({
      fill: "#ffffff",
      fontFamily: this.activeGameData.gameTextStyle.gameFont,
      fontSize: 60,
      fontWeight: "bolder",
      lineJoin: "bevel",
      strokeThickness: 1
  });

    this.gameLeftText= new PIXI.Text(this.gameLeft+"",style);
    this.gameLeftText.anchor.set(.5);
    this.parent.addChild(this.gameLeftText);
    this.gameLeftText.y=70;
    this.gameLeftLabelText= new PIXI.Text(this.gameLeft+"",style);
    this.gameLeftLabelText.anchor.set(.5);
    this.parent.addChild(this.gameLeftLabelText);
    this.gameLeftLabelText.x=0;
    this.gameLeftLabelText.scale.set(.5);
    this.gameLeftLabelText.y=25;

    ///-- test

    this.setGambleLeft(0);

  }
  public setPosition=(newPosX:number,newPosY:number):void=>
  {
      this.parent.position.set(newPosX,newPosY);
  }
  public setGambleLeft=(gambleLeft:number):void=>
  {
    this.gameLeft=gambleLeft;
    this.gameLeftText.text=this.gameLeft+"";
  }
  public Setlabel=(label:string):void=>
  {
    this.gameLeftLabelText.text=label;
  }
}



class InstructionsBar
{ 
  private parent= new PIXI.Container();
  private activeGameData:CommonData;
  private bgImage=new PIXI.Sprite(PIXI.Texture.fromFrame('gamble_NotifBar.png'));
  private miniLogo=new PIXI.Sprite(PIXI.Texture.fromFrame('gambleMiniLogo.png'));
  private instructionText:PIXI.Text;
  private tweenLogo:PIXI.tween.Tween;
  private waitTween:PIXI.tween.Tween;
  private tweenBG:PIXI.tween.Tween;
  private tweenText:PIXI.tween.Tween;
  private maskBar:PIXI.Graphics;
  constructor(parent:PIXI.Container,activeGameData:CommonData)
  {
    parent.addChild(this.parent);
    this.activeGameData=activeGameData;

    this.bgImage.anchor.set(.5);
    this.miniLogo.anchor.set(.5);
    this.parent.addChild(this.bgImage);
    this.parent.addChild(this.miniLogo);



    
    const style = new PIXI.TextStyle({
      fill: "#ffffff",
      fontFamily: this.activeGameData.gameTextStyle.gameFont,
      fontSize: 30,
      fontWeight: "normal",
      lineJoin: "bevel",
      strokeThickness: 1
  });

    this.instructionText= new PIXI.Text(activeGameData.gameTextGeneral.gambleNoteSplitPart1,style);
    this.instructionText.anchor.set(.5);
    this.parent.addChild(this.instructionText);
    // this.instructionText.x=-this.bgImage.width+160;

  this.maskBar= new PIXI.Graphics().beginFill(0xffffff).drawRect(0,-50,this.bgImage.width+20,100).endFill();
  this.miniLogo.addChild(this.maskBar);

  this.bgImage.mask=this.maskBar;
  this.instructionText.mask=this.maskBar;
    this.tweenLogo = PIXI.tweenManager.createTween(this.miniLogo);
        this.tweenLogo.time = 800;
        this.tweenLogo.loop = false;  
        this.tweenLogo.easing = PIXI.tween.Easing.outSine();
        this.tweenLogo.from({x:-this.bgImage.width/3,alpha:1}).to({x:-this.bgImage.width/2,alpha:1})
   

        this.waitTween = PIXI.tweenManager.createTween(this.miniLogo);
        this.waitTween.time = 5000;   
        this.waitTween.loop = false;

        this.tweenLogo.chain(this.waitTween);
        this.tweenLogo.start();
        this.waitTween.on("end",this.swapText);  

        this.tweenBG = PIXI.tweenManager.createTween(this.bgImage);
        this.tweenBG.time =    this.tweenLogo.time;
        this.tweenBG.loop = false;  
        this.tweenBG.easing =   this.tweenLogo.easing;
        this.tweenBG.from({x:-this.bgImage.width/10,alpha:1}).to({x:0,alpha:1});


        this.tweenText = PIXI.tweenManager.createTween(this.instructionText);
        this.tweenText.time =    this.tweenLogo.time;
        this.tweenText.loop = false;  
        this.tweenText.easing =   this.tweenLogo.easing;
        this.tweenText.from({x:-this.bgImage.width/10,alpha:0}).to({x:0,alpha:1});
   
  }
  public setVisible=(bool:boolean):void=>
  {
    this.parent.alpha=bool?1:0;
    if(bool)
    {
      this.tweenLogo.start();
      this.tweenBG.start();
    }
    else
    {
      this.tweenLogo.stop();
      this.tweenBG.stop();
    }

   
    this.waitTween.stop();
  }
  public setPosition=(newPosX:number,newPosY:number):void=>
  {
      this.parent.position.set(newPosX,newPosY);
  }
  private swapText=():void=>
  { 
    if(this.instructionText.text===this.activeGameData.gameTextGeneral.gambleNoteSplitPart1)
    {
      this.instructionText.text=this.activeGameData.gameTextGeneral.gambleNoteSplitPart2;
    }
    else
    {
      this.instructionText.text=this.activeGameData.gameTextGeneral.gambleNoteSplitPart1;
    }
    this.tweenLogo.reset();
    this.tweenLogo.start();
    this.tweenBG.reset();
    this.tweenBG.start();

    this.tweenText.delay=0;
    this.tweenText.reset();
    this.tweenText.start();
  }
  // private 
  // public setScore=(newScoreRed:number, newScoreBlue:number):void=>
  // {
  //   this.scoreRed=newScoreRed;
  //   this.scoreBlue=newScoreBlue;
  //   this.scoreRedDisplayText.text=this.scoreRed+"";
  //   this.scoreBlueDisplayText.text=this.scoreBlue+"";
  // }
}

class ResultHistoryViewer

{
    private parent = new PIXI.Container();
    private parentEmojis = new PIXI.Container();
    private smileyFrame= new PIXI.Sprite(PIXI.Texture.fromFrame('smiley_barBG.png'))
    private smileyFace:PIXI.Sprite[]=[];// = new PIXI.Sprite(PIXI.Texture.fromFrame('smilery_win.png'));
    private totalResult:number=5; 
    private activeGameData:CommonData;
    private maskBot = new PIXI.Graphics().beginFill(0xffffff,0.5).drawRect(-300,-132,600,150).endFill();
    private blueWintexture=  PIXI.Texture.fromFrame('smiley_blue.png');
    private redWintexture=  PIXI.Texture.fromFrame('smiley_red.png');
    private noWinTexture=  PIXI.Texture.fromFrame('smilery_win.png');
    private firstResultTween:PIXI.tween.Tween;
    constructor(parent:PIXI.Container,activeGameData:CommonData)
    { 
      this.activeGameData=activeGameData;
      this.activeGameData
        parent.addChild(this.parent);
        this.parent.addChild(this.smileyFrame);
        this.smileyFrame.anchor.set(.5);
        this.parent.addChild(this.parentEmojis);
      this.createResultDisplayer();
      this.createTween();
      this.parent.addChild(this.maskBot);
      this.smileyFrame.mask=this.maskBot;

      this.loadHistory([0,1,2]);
    }
    private createResultDisplayer=():void=>
    { 
      let spacing=20;
        for (let i = 0; i < this.totalResult; i++) {
          this.smileyFace[i]= new PIXI.Sprite(PIXI.Texture.fromFrame('smilery_win.png'));
          this.smileyFace[i].anchor.set(.5);
          this.smileyFace[i].x= (this.smileyFace[i].width+spacing)*i;
          this.smileyFace[i].y=-20;
          this.parentEmojis.addChild (this.smileyFace[i]);
        }
        this.parentEmojis.x=-this.parentEmojis.width/2+this.smileyFace[0].width/2;
    }
    private createTween=():void=>
    {
      this.firstResultTween = PIXI.tweenManager.createTween( this.smileyFace[0]);
      this.firstResultTween.time = 750;
      this.firstResultTween.loop=false;
      // this.firstResultTween.pingPong=true;
      this.firstResultTween.easing = PIXI.tween.Easing.outBack();
      this.firstResultTween
    .from({ scale: { x: 2, y: 2 } })
    .to({ scale: { x:1, y:1 } });
    }
    private playTween=(bool:boolean):void=>
    {    
      this.smileyFace[0].scale.set(1);
      if(bool)
      {
        this.firstResultTween.reset();
        this.firstResultTween.start();
      }
      else
      {
        this.firstResultTween.reset();
        this.firstResultTween.stop();
     
      }
    
    }
    public loadHistory=(historyArray:number[]):void=>
    {
    
        this.setVisible(true);

        this.clearAll();

        if(historyArray.length>0)
        { 
          // let arrayToUse=historyArray;
          // if(historyArray<)
          this.playTween(true);
    
          let lengthToCheck=historyArray.length<6 ?historyArray.length:this.totalResult;
    
          for (let i = 0; i < lengthToCheck; i++) {
            if(historyArray[i]===0 ||historyArray[i]===2)
            {
                this.smileyFace[i].texture=this.redWintexture;
            }
            else
            {
              if(historyArray[i]===1 ||historyArray[i]===3)
              {
                this.smileyFace[i].texture=this.blueWintexture;
              }
            }
            this.smileyFace[i].alpha=1;
            
          }
        }
    }
    public clearAll=():void=>
    { 
      for (let i = 0; i < this.smileyFace.length; i++) {
      
            this.smileyFace[i].texture=this.noWinTexture;
            this.smileyFace[i].alpha=.25;
        
      }
      this.playTween(false);
    }
    public setVisible=(bool:boolean):void=>
    {
  
        this.parent.alpha=bool?1:0;

    }
    public setPosition=(newPosX:number,newPosY:number):void=>
    {
        this.parent.position.set(newPosX,newPosY);
    }


}

class GambleAmountDisplayer
{
  private parent=new PIXI.Container();
  private activeGameData:CommonData;//for the font etc
  private backgroundFrame= new PIXI.Sprite(PIXI.Texture.fromFrame('smiley_barBG.png'));
  private textLabel:PIXI.Text;
  private textValue:PIXI.Text;

  constructor(parent:PIXI.Container,activeGameData:CommonData)

  {
    this.activeGameData=activeGameData;
    parent.addChild(this.parent);
    this.createBackground();
    this.createText();
  }
private createBackground=():void=>
{
  this.parent.addChild(this.backgroundFrame);
  this.backgroundFrame.anchor.set(.5);
}

private createText=():void=>
{ 

  //define text style
  const styleTitel = new PIXI.TextStyle({
    fill: "#ffffff",
    fontFamily:   this.activeGameData.gameTextStyle.gameFont,
    fontSize: 25,
    // fontStyle: "italic",
    fontWeight: "bolder",
    lineJoin: "round",
    strokeThickness: 10
});
const styleBody = new PIXI.TextStyle({
  fill: "#ffffff",
  fontFamily:   this.activeGameData.gameTextStyle.gameFont,
  fontSize: 50,
  // fontStyle: "italic",
  fontWeight: "bolder",
  lineJoin: "round",
  strokeThickness: 10
});

//create text
this.textLabel= new PIXI.Text('setLabel',styleTitel);
this.textValue= new PIXI.Text('setValue',styleBody);
this.textLabel.anchor.set(.5);
this.textValue.anchor.set(.5);
this.textLabel.y=-30;
this.textValue.y=20;
this.parent.addChild(this.textLabel);
this.parent.addChild(this.textValue);
}
public setLabelText=(newText:string):void=>
{
  this.textLabel.text=newText;
}
public setValueText=(newText:string):void=>
{
  this.textValue.text=newText;
}
public setPosition=( posX:number,posY:number):void=>
{
 this.parent.position.set(posX,posY);
}
public setScale=( newScale:number):void=>
{
 this.parent.scale.set(newScale,newScale);
}
}

class WinLoseTextDisplayer
{

  private parent= new PIXI.Container();
  private gameresultText: PIXI.Text;
  private gameresultTextTween: PIXI.tween.Tween;
  private activeGameData:CommonData;
  
  constructor(parent:PIXI.Container,activeGameData:CommonData)
  {
    this.activeGameData=activeGameData;
    parent.addChild(this.parent);
    this.createTextAndTween();
  }
  private createTextAndTween=():void=>
  {

      
    let textStyle = new PIXI.TextStyle({
      fontFamily: this.activeGameData.gameTextStyle.gameFont,
      fontSize: 100,
      fill: "#ffffff",
      fontWeight: "bold",
      lineHeight: 40,
      align: "center",

      dropShadow: true,
      dropShadowColor: "#000000",
      dropShadowBlur: 40,
      dropShadowAngle: Math.PI / 6,
      dropShadowDistance: 0,
      stroke:0x000000,
      strokeThickness:10
    });


    this.gameresultText = new PIXI.Text(
      this.activeGameData.gameTextGeneral.win,
      textStyle
    );
    this.gameresultText.anchor.set(0.5);
      this.parent.addChild(this.gameresultText);


    ///create tween
    this.gameresultTextTween = PIXI.tweenManager.createTween(
      this.gameresultText
    );
    this.gameresultTextTween.time = 500;
    this.gameresultTextTween.loop=false;
    this.gameresultTextTween.easing = PIXI.tween.Easing.outBack();
    this.gameresultTextTween
      .from({ alpha: 1, scale: { x: 3, y: 1.5 } })
      .to({ alpha: 1, scale: { x: 1, y: 1 } });
  }
  public displayTextResult=(isWin:boolean)=>
  {
      let winText='   '+this.activeGameData.gameTextGeneral.win+'   ';
      let loseText='   '+this.activeGameData.gameTextGeneral.lose+'   ';
      this.gameresultText.text= isWin?winText:loseText ;
      this.clear();//clear first then start;
      this.gameresultTextTween.start();
  }
  public setPosition=(newPosX:number,newPosY:number):void=>
  {
    this.parent.x=newPosX;
    this.parent.y=newPosY;
  }
  public clear=():void=>
  {
    this.gameresultText.alpha = 0;
    this.gameresultTextTween.reset();
    this.gameresultTextTween.stop();
  }
}
